<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">账户常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">海星云配置</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>海星云配置？
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>

              <div id="conf">
                <table  style="width: 100%; border-collapse: collapse;text-align: center" border="1" >
                  <caption>海星云配置</caption>
                  <thead>
                  <tr>
                    <th >线路</th>
                    <th >显卡配置</th>
                    <th >CPU配置</th>
                    <th >运行内存</th>
                    <th >可写入空间</th>
                    <th >收费</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td rowspan="3">4090</td>
                    <td >RTX4090</td>
                    <td rowspan="2">I9-10900X 9核</td>
                    <td rowspan="3">56G</td>
                    <td rowspan="3">500G</td>
                    <td rowspan="6">3点</td>
                  </tr>
                  <tr>
                    <td>RTX4090&nbsp;&nbsp;*3</td>
                  </tr>
                  <tr>
                    <td>尽情期待</td>
                    <td>尽情期待</td>
                  </tr>
                  <tr>
                    <td colspan="5"></td>
                  </tr>
                  <tr>
                    <td>高配</td>
                    <td>RTX3090&nbsp;&nbsp;*1</td>
                    <td>I9-10900X 5核</td>
                    <td>28G</td>
                    <td>250G</td>
                  </tr>
                  <tr>
                    <td colspan="5"></td>
                  </tr>
                  <tr>
                    <td rowspan="2">普通</td>
                    <td>RTX3060ti*1</td>
                    <td>I9-10900X 4核</td>
                    <td rowspan="2">18-28G</td>
                    <td rowspan="2">150G</td>
                    <td rowspan="2">2点</td>
                  </tr>
                  <tr>
                    <td>RTX3070</td>
                    <td>I9-10900X 4核</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>少量2060s</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <div></div>
              <br />1.北方线路 3060Ti + i9 10900X（i9 9900X）+16G内存+28T全固态存储
              <br />2.广东线路 3070 + i9 10900X（i9 9900X）+28G内存+28T全固态存储
            </div>

          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./Account')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}

#conf table th{
  width: 10.6%;
  height: 46px;
  text-align: center;
}
#conf table td{
  line-height: 36px;
}
#conf table caption{
  font-size: 46px;
  text-align: center;
  margin-bottom: 13px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/Account/Configuration.vue